import { useIntl } from "react-intl";

import { type Traveller } from "@/types/types";

type Props = {
  selectedTravellers: Traveller[];
};

export function TravellersListSummary({ selectedTravellers }: Props) {
  const intl = useIntl();

  return (
    <div className="flex flex-col gap-2">
      {selectedTravellers.map((traveller) => {
        return (
          <div
            key={traveller.id}
            className="flex flex-col gap-2 rounded-2xl bg-white"
          >
            <div className="flex w-full items-center justify-between gap-2">
              <div className="flex flex-col" data-sentry-mask>
                <span className="text-base font-medium text-text-primary">
                  {traveller.firstName} {traveller.lastName}
                </span>
                <span className="text-sm text-text-tertiary">
                  {intl.formatMessage({
                    defaultMessage: "Passport ID",
                    description: "Label for the passport number field",
                  })}
                  : {traveller.passportNumber || "-"}
                </span>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
